<template>
  <div>
    <WebsiteHeader></WebsiteHeader>
    <div v-if="getCurrentUser" class="mt-16">
      <v-row justify="center">
        <v-overlay :z-index="zIndex" :value="overlay">
          <div v-if="showNewSchoolForm">
            <v-form>
              <v-container>
                <v-row>
                  <v-col :cols="isMobile ? 12 : 4">
                    <v-text-field
                      v-model="school.schname"
                      label="Name of School"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col :cols="isMobile ? 12 : 4">
                    <v-text-field
                      v-model="school.physical_address"
                      label="School Physical Address"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col :cols="isMobile ? 12 : 4">
                    <v-text-field
                      v-model="school.city"
                      label="City or Town or Suburb"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col :cols="isMobile ? 12 : 4">
                    <v-text-field
                      v-model="school.sch_tel"
                      label="School Contact Number"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col :cols="isMobile ? 12 : 4">
                    <v-btn
                      rounded
                      dark
                      large
                      class="mt-2"
                      color="red"
                      @click="showNewSchoolForm = false"
                      >Go Back</v-btn
                    ><v-btn
                      rounded
                      dark
                      large
                      class="mt-2 ml-2"
                      color="teal"
                      @click="createSchool()"
                      >Add School</v-btn
                    ></v-col
                  >
                </v-row>
              </v-container>
            </v-form>
          </div>
          <div v-else>
            <v-toolbar dark color="teal">
              <v-toolbar-title>Select Or Add New School</v-toolbar-title>
              <v-autocomplete
                v-model="selectedSchoolEmis"
                :items="schools"
                :search-input.sync="search"
                cache-items
                class="mx-4"
                flat
                hide-no-data
                hide-details
                label="Select Or Add New School"
                solo-inverted
              ></v-autocomplete>
              <!-- <v-btn icon>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn> -->
            </v-toolbar>

            <v-btn
              rounded-pill
              :color="getThemeColor"
              dark
              class="mt-4"
              @click="submitSelection()"
            >
              Submit Selection
            </v-btn>
          </div>

          <!-- <v-btn class="white--text" color="teal" @click="overlay = false">
            Hide Overlay
          </v-btn> -->
        </v-overlay>
      </v-row>
    </div>
    <Loader />
    <TemplateFooter></TemplateFooter>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import WebsiteHeader from "@/components/SchoolWebsite/WebsiteHeader.vue";
import TemplateFooter from "@/components/SchoolWebsite/WebsiteFooter.vue";
import Loader from "@/components/Loader.vue";

export default {
  components: {
    WebsiteHeader,
    TemplateFooter,
    Loader,
  },
  computed: {
    getCurrentUser() {
      return this.$store.getters.getCurrentUser;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
  },
  data: () => ({
    showNewSchoolForm: false,
    search: "",
    schools: [],
    selectedSchoolEmis: null,
    overlay: true,
    zIndex: 1,
    school: {
      schname: null,
      domain: "127.0.0.1",
      physical_address: "",
      city: "",
      sch_tel: "",
    },
  }),
  updated() {
    this.$store.commit("setIsMobile", this.$vuetify.breakpoint.mobile);
  },
  mounted() {
    this.$store.commit("setIsMobile", this.$vuetify.breakpoint.mobile);
    this.getAllSchools();
  },
  methods: {
    getAllSchools() {
      axios.getData("/get-all-schools").then((schools) => {
        if (schools.length > 0) {
          this.schools = [];
          schools.forEach((school) => {
            this.schools.push({
              ...school,
              text: school.schname,
              value: school.emis,
            });
          });
          this.schools.push({
            text: "ADD MY SCHOOL",
            value: "add-school",
          });
          this.schools.unshift({
            text: "ADD MY SCHOOL",
            value: "add-school",
          });
        }
      });
    },
    submitSelection() {
      if (this.selectedSchoolEmis == "add-school") {
        this.showNewSchoolForm = true;
      } else {
        this.showNewSchoolForm = false;
        this.updateUserSchool();
      }
    },
    updateUserSchool() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/change-user-school",
          { emis: this.selectedSchoolEmis },
          this.getAccessToken
        )
        .then((response) => {
          this.$store.commit("setLoader", false);
          this.$store.commit("setCurrentUser", response.user);

          this.$store.commit("setUserSchool", response.school);
          this.$store.commit(
            "setThemeColor",
            response.site_settings.primary_bg_color
          );
          this.$store.commit(
            "setSecondaryColor",
            response.site_settings.secondary_bg_color
          );
          this.$store.commit("setAppName", response.school.schname);

          localStorage.setItem("user", JSON.stringify(response.user));
          localStorage.setItem(
            "themeColor",
            response.site_settings.primary_bg_color
          );
          localStorage.setItem(
            "secondaryColor",
            response.site_settings.secondary_bg_color
          );
          localStorage.setItem("appName", response.school.schname);
          localStorage.setItem("userSchool", JSON.stringify(response.school));
          this.$router.push({ name: "switchboard" });
        });
    },
    createSchool() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/create-new-school",
          { school: this.school },
          this.getAccessToken
        )
        .then((response) => {
          this.$store.commit("setLoader", false);

          this.$store.commit("setCurrentUser", response.user);

          this.$store.commit("setUserSchool", response.school);
          this.$store.commit(
            "setThemeColor",
            response.site_settings.primary_bg_color
          );
          this.$store.commit(
            "setSecondaryColor",
            response.site_settings.secondary_bg_color
          );
          this.$store.commit("setAppName", response.school.schname);

          localStorage.setItem("user", JSON.stringify(response.user));
          localStorage.setItem(
            "themeColor",
            response.site_settings.primary_bg_color
          );
          localStorage.setItem(
            "secondaryColor",
            response.site_settings.secondary_bg_color
          );
          localStorage.setItem("appName", response.school.schname);
          localStorage.setItem("userSchool", JSON.stringify(response.school));
          this.$router.push({ name: "switchboard" });
        });
    },
  },
};
</script>
